import {observer} from "mobx-react-lite"
import React from "react"
import {match, Route, Switch} from "react-router-dom";
import {CategoriesForAttributes} from "./CategoriesForAttributes";
import {CategoryAttributesPage} from "./CategoryAttributesPage";
import ValueCompareComponent from "./ValueCompareComponent";
import StepNavigation from "../../components/StepNavigation";
import {appPages} from "../../App";


export const AttributesCategoryComparePage = observer(({match}: { match: match }) => {
    return <div>
        <h1>4. Сопоставление характеристик</h1>

        <Switch>
            <Route exact path={appPages.offerAttributes + '/'}>
                <CategoriesForAttributes/>
                <StepNavigation next={appPages.offersExport} back={appPages.generalOfferAttributes}/>
            </Route>
            <Route exact path={appPages.offerAttributes + '/category/:category_id'} component={CategoryAttributesPage}/>
            <Route path={appPages.offerAttributes + '/category/:category_id/attribute/:attribute_id'} component={ValueCompareComponent}/>
        </Switch>

    </div>
})